import { generateSelectColumn } from 'components/DataTable/SelectColumn'
import { SummaryPacketsCheckboxGroupContext } from './CheckboxContextProvider'

export default generateSelectColumn(SummaryPacketsCheckboxGroupContext)
